import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { toast } from 'react-toastify'

const UPDATE_INTERVAL = 60 * 60 * 1000 // 60 minutes

export default function ReloadPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      if (!registration) return
      setInterval(() => { registration.update() }, UPDATE_INTERVAL)
    },
  })

  useEffect(() => {
    if (!needRefresh) return
    toast(
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span>Dostupna je nova verzija</span>
        <button
          onClick={() => updateServiceWorker(true)}
          style={{
            background: '#fff',
            color: '#002d56',
            border: 'none',
            borderRadius: 4,
            padding: '4px 12px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Ažuriraj
        </button>
      </div>,
      { autoClose: false, closeOnClick: false }
    )
  }, [needRefresh, updateServiceWorker])

  return null
}
